export const storePaths = paths => ({
  type: 'STORE_PATHS',
  paths,
})

export const storeFarthestPath = path => {
  return {
    type: 'STORE_FARTHEST_PATH',
    path,
  }
}

const initialState = {
  paths: [],
  farthestPath: null,
}

export default function contentReducer(state = initialState, action) {
  switch (action.type) {
    case 'STORE_PATHS': {
      return {
        ...state,
        paths: action.paths,
      }
    }
    case 'STORE_FARTHEST_PATH': {
      return {
        ...state,
        farthestPath: action.path,
      }
    }
    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ../core/src/store/path.js